import { render, staticRenderFns } from "./CustomeSnoozeModal.vue?vue&type=template&id=5015ad68&scoped=true&"
import script from "./CustomeSnoozeModal.vue?vue&type=script&lang=js&"
export * from "./CustomeSnoozeModal.vue?vue&type=script&lang=js&"
import style0 from "./CustomeSnoozeModal.vue?vue&type=style&index=0&id=5015ad68&prod&lang=scss&"
import style1 from "./CustomeSnoozeModal.vue?vue&type=style&index=1&id=5015ad68&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5015ad68",
  null
  
)

export default component.exports